// @flow

import React from 'react';
import { connect } from 'react-redux';
import QuestionsMenu from './questions/QuestionsMenu';
import QuestionsList from './questions/QuestionsList';
import { getQuestions } from '../reducers/questions';
import * as QuestionsAction from '../actions/questions';
import type { Question, QuestionType } from '../types';

type Props = {
  questions: Array<Question>,
  showValidationErrors: boolean,
  addQuestion: () => void,
  updateQuestion: (question: Question) => void,
  changeQuestionOrder: (question: Question, order: number) => void,
  changeQuestionType: (question: Question, type: QuestionType) => void,
  deleteQuestion: (question: Question) => void,
};

const mapStateToProps = state => ({
  questions: getQuestions(state),
});

class QuestionsCard extends React.Component<Props> {
  props: Props;

  render() {
    const {
      questions,
      showValidationErrors,
      addQuestion,
      updateQuestion,
      changeQuestionOrder,
      changeQuestionType,
      deleteQuestion,
    } = this.props;

    return (
      <div>
        <QuestionsMenu onAddQuestion={addQuestion} />
        <QuestionsList
          questions={questions}
          showValidationErrors={showValidationErrors}
          onUpdateQuestion={updateQuestion}
          onChangeQuestionOrder={changeQuestionOrder}
          onChangeQuestionType={changeQuestionType}
          onDeleteQuestion={deleteQuestion}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  addQuestion: QuestionsAction.addQuestion,
  updateQuestion: QuestionsAction.updateQuestion,
  changeQuestionOrder: QuestionsAction.changeQuestionOrder,
  changeQuestionType: QuestionsAction.changeQuestionType,
  deleteQuestion: QuestionsAction.deleteQuestion,
})(QuestionsCard);



// WEBPACK FOOTER //
// ./src/modules/survey/components/QuestionsCard.js